import { css } from 'lit';
export const ButtonStyles = css `
:host {
    --button-padding: 0 1.5em;
    --button-mobile-padding: 0 0.5em;
    --button-tablet-padding: 0 1em;
    --button-margin-top: 0;
    --button-margin-bottom: 0;
    --button-margin-left: 0;
    --button-margin-right: 0;
}
    
.base-button {
    margin-top: var(--button-margin-top);
    margin-bottom: var(--button-margin-bottom);
    margin-left: var(--button-margin-left);
    margin-right: var(--button-margin-right);
    height: 36px;
    width: 100%;
    line-height: 36px;
    display: flex;
    align-items: center;
    text-decoration: none;
    justify-content: center;
    box-shadow: var(--button-shadow);
    font-family: var(--button-font-family);
    font-weight: var(--button-font-weight);
    font-size: var(--button-font-size);
    padding: var(--button-padding);
    border-radius: var(--button-border-radius);
    border: var(--button-border);
    transition: var(--button-transition, box-shadow .2s ease, background .2s ease, color .2s ease, border-color .2s ease);
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.base-button:hover {
    box-shadow: var(--button-shadow-hover);
}

:host([nopointerevents="true"]) .dn-button:active {
    pointer-events: none;
}

:host([ismobile="true"]) .dn-button {
    height:42px;
}

:host([ismobile="true"]) button {
    height: 42px;
    padding: 0 1em;
}

.dn-button {
    background: var(--button-primary);
}

.dn-button dn-common-icon {
    --icon-color: var(--background);
}

.button--primary {
  background: var(--button-primary-background);
  color: var(--button-primary-color);
  border: var(--button-primary-border);
}

.button--primary:hover {
  background: var(--button-primary-hover-background, var(--button-primary-hover));
  color: var(--button-primary-hover-color, var(--button-primary-color));
  border: var(--button-primary-hover-border, var(--button-primary-border));
}

.button--primary:active,
.button--primary:focus-visible {
  background: var(--button-primary-active-background, var(--primary-color-dark));
  color: var(--button-primary-active-color, white);
  border: var(--button-primary-active-border, 1px solid var(--primary-color-light));
}

.button--primary:disabled,
.button--primary.disabled {
  background: var(--button-primary-disabled-background, var(--primary-color-light));
  color: var(--button-primary-disabled-color, white);
  border: var(--button-primary-disabled-border, 1px solid var(--primary-color-light));
  opacity: var(--button-disabled-opacity, 0.3);
  cursor: default;
  box-shadow: none;
}

.button--secondary {
  background: var(--button-secondary-background);
  color: var(--button-secondary-color);
  border: var(--button-secondary-border);
}

.button--secondary:hover {
  background: var(--button-secondary-hover-background, var(--button-primary-hover));
  color: var(--button-secondary-hover-color, var(--button-primary-color));
  border: var(--button-secondary-hover-border, var(--button-primary-border));
}

.button--secondary:active,
.button--secondary:focus-visible {
  background: var(--button-secondary-active-background, var(--primary-color-dark));
  color: var(--button-secondary-active-color, white);
  border: var(--button-secondary-active-border, 1px solid var(--primary-color-light));
}

.button--secondary:disabled,
.button--secondary.disabled {
  background: var(--button-secondary-disabled-background, var(--primary-color-light));
  color: var(--button-secondary-disabled-color, white);
  border: var(--button-secondary-disabled-border, 1px solid var(--primary-color-light));
  opacity: var(--button-disabled-opacity, 0.3);
  cursor: default;
  box-shadow: none;
}

.button--tertiary {
  background: var(--button-tertiary-background);
  color: var(--button-tertiary-color);
  border: var(--button-tertiary-border);
}

.button--tertiary:hover {
  background: var(--button-tertiary-hover-background, var(--button-primary-hover));
  color: var(--button-tertiary-hover-color, var(--button-primary-color));
  border: var(--button-tertiary-hover-border, var(--button-primary-border));
}

.button--tertiary:active,
.button--tertiary:focus-visible {
  background: var(--button-tertiary-active-background, var(--primary-color-dark));
  color: var(--button-tertiary-active-color, white);
  border: var(--button-tertiary-active-border, 1px solid var(--primary-color-light));
}

.button--tertiary:disabled,
.button--tertiary.disabled {
  background: var(--button-tertiary-disabled-background, var(--primary-color-light));
  color: var(--button-tertiary-disabled-color, white);
  border: var(--button-tertiary-disabled-border, 1px solid var(--primary-color-light));
  opacity: var(--button-disabled-opacity, 0.3);
  cursor: default;
  box-shadow: none;
}

.button--success {
  background: var(--button-success-background);
  color: var(--button-success-color);
  border: var(--button-success-border);
}

.button--success:hover {
  background: var(--button-success-hover-background, var(--button-primary-hover));
  color: var(--button-success-hover-color, var(--button-primary-color));
  border: var(--button-success-hover-border, var(--button-primary-border));
}

.button--success:active,
.button--success:focus-visible {
  background: var(--button-success-active-background, var(--primary-color-dark));
  color: var(--button-success-active-color, white);
  border: var(--button-success-active-border, 1px solid var(--primary-color-light));
}

.button--success:disabled,
.button--success.disabled {
  background: var(--button-success-disabled-background, var(--primary-color-light));
  color: var(--button-success-disabled-color, white);
  border: var(--button-success-disabled-border, 1px solid var(--primary-color-light));
  opacity: var(--button-disabled-opacity, 0.3);
  cursor: default;
  box-shadow: none;
}

.button--warning {
  background: var(--button-warning-background);
  color: var(--button-warning-color);
  border: var(--button-warning-border);
}

.button--warning:hover {
  background: var(--button-warning-hover-background, var(--button-primary-hover));
  color: var(--button-warning-hover-color, black);
  border: var(--button-warning-hover-border, var(--button-primary-border));
}

.button--warning:active,
.button--warning:focus-visible {
  background: var(--button-warning-active-background, var(--primary-color-dark));
  color: var(--button-warning-active-color, black);
  border: var(--button-warning-active-border, 1px solid var(--primary-color-light));
}

.button--warning:disabled,
.button--warning.disabled {
  background: var(--button-warning-disabled-background, var(--primary-color-light));
  color: var(--button-warning-disabled-color, black);
  border: var(--button-warning-disabled-border, 1px solid var(--primary-color-light));
  opacity: var(--button-disabled-opacity, 0.3);
  cursor: default;
  box-shadow: none;
}

.button--discard {
  background: var(--button-discard-background);
  color: var(--button-discard-color);
  border: var(--button-discard-border);
}

.button--discard dn-common-icon {
    --icon-color: var(--text-main);
}

.button--discard:hover {
  background: var(--button-discard-hover-background, var(--button-primary-hover));
  color: var(--button-discard-hover-color, var(--button-primary-color));
  border: var(--button-discard-hover-border, var(--button-primary-border));
}

.button--discard:active,
.button--discard:focus-visible {
  background: var(--button-discard-active-background, var(--primary-color-dark));
  color: var(--button-discard-active-color, white);
  border: var(--button-discard-active-border, 1px solid var(--primary-color-light));
}

.button--discard:disabled,
.button--discard.disabled {
  background: var(--button-discard-disabled-background, var(--primary-color-light));
  color: var(--button-discard-disabled-color, white);
  border: var(--button-discard-disabled-border, 1px solid var(--primary-color-light));
  opacity: var(--button-disabled-opacity, 0.3);
  cursor: default;
  box-shadow: none;
}

.button--grey {
  background: var(--button-grey-background);
  color: var(--button-grey-color);
  border: var(--button-grey-border);
}

.button--grey:hover {
  background: var(--button-grey-hover-background, var(--button-primary-hover));
  color: var(--button-grey-hover-color, var(--button-primary-color));
  border: var(--button-grey-hover-border, var(--button-primary-border));
}

.button--grey:active,
.button--grey:focus-visible {
  background: var(--button-grey-active-background, var(--primary-color-dark));
  color: var(--button-grey-active-color, white);
  border: var(--button-grey-active-border, 1px solid var(--primary-color-light));
}

.button--grey:disabled,
.button--grey.disabled {
  background: var(--button-grey-disabled-background, var(--primary-color-light));
  color: var(--button-grey-disabled-color, white);
  border: var(--button-grey-disabled-border, 1px solid var(--primary-color-light));
  opacity: var(--button-greyd-opacity, 0.3);
  cursor: default;
  box-shadow: none;
}

.button--clear {
  background: var(--button-clear-background);
  color: var(--button-clear-color);
  border: var(--button-clear-border);
}

.button--clear dn-common-icon {
  --icon-color: var(--text-main, initial);
}

.button--clear:hover {
  background: var(--button-clear-hover-background, var(--button-primary-hover));
  color: var(--button-clear-hover-color, var(--button-primary-color));
  border: var(--button-clear-hover-border, var(--button-primary-border));
}

.button--clear:active,
.button--clear:focus-visible {
  background: var(--button-clear-active-background, var(--primary-color-dark));
  color: var(--button-clear-active-color, white);
  border: var(--button-clear-active-border, 1px solid var(--primary-color-light));
}

.button--clear:disabled,
.button--clear.disabled {
  background: var(--button-clear-disabled-background, var(--primary-color-light));
  color: var(--button-clear-disabled-color, white);
  border: var(--button-clear-disabled-border, 1px solid var(--primary-color-light));
  opacity: var(--button-cleard-opacity, 0.3);
  cursor: default;
  box-shadow: none;
}

:host([ismobile="true"]) .base-button {
    padding: var(--button-mobile-padding);
}

:host([istablet="true"]) .base-button {
    padding: var(--button-tablet-padding);
}

.base-button:focus {
    outline: 0;
}

.base-button:disabled {
    opacity:0.3;
    cursor: default;
}
  
[data-animation] {
    position: relative;
    overflow: hidden;
}

.highlight {
  height: 42px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  top: 0px;
  position: absolute;
  left: 0;
}

.ripple {
    width: 2px;
    height: 2px;
    position: absolute;
    border-radius: 50%;
    box-shadow: 50px rgba(0, 0, 0, 0.2);
    background-color: rgba(255, 255, 255, 1);
    -webkit-animation: rippleEffect 0.5s;
            animation: rippleEffect 0.5s;
}

dn-common-icon {
    pointer-events: none;
}

@-webkit-keyframes rippleEffect {
    0% {
        opacity: 0.1;
        -webkit-transform: scale(1);
              transform: scale(1);
    }
    100% {
        opacity: 0.6;
        -webkit-transform: scale(var(--scale));
              transform: scale(var(--scale));
    }
}

@keyframes rippleEffect {
    0% {
        opacity: 0.1;
        -webkit-transform: scale(1);
              transform: scale(1);
    }
    100% {
        opacity: 0.6;
        -webkit-transform: scale(var(--scale));
              transform: scale(var(--scale));
    }
}

`;
